import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=c1a7805c&scoped=true&"
import script from "./CreateEvent.vue?vue&type=script&lang=js&"
export * from "./CreateEvent.vue?vue&type=script&lang=js&"
import style0 from "./CreateEvent.vue?vue&type=style&index=0&id=c1a7805c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a7805c",
  null
  
)

export default component.exports